function Username({ username }) {
  return username || "匿名用户";
}

export default Username;
